import React from 'react';

import { Circle, ReportToolTip } from 'pages/reports/components/StudentMetricsDisplay/StudentMetricsDisplay';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

interface ResourceMetricsDisplayProps {
    calculateHourMinFormat: (minutes: number) => string;
    resourceMetrics: {
        averageScore: number;
        averageTimeSpent: number;
        resourcesCompletedPercent: number;
        resourcesStartedPercent: number;
    };
}

export const ResourceMetricsDisplay: React.FC<ResourceMetricsDisplayProps> = ({
    calculateHourMinFormat,
    resourceMetrics
}) => {

    const { formatMessage } = useIntl();

    return ((
        <Container fluid className="px-0">
            <Row className="g-3 align-items-stretch mx-0">
                {/* Student Distribution */}
                <Col className="ps-0" md="6" xs="12">
                    <Card className="p-3 shadow-sm h-100">
                        <h6 className="fw-semibold mb-3">
                            <FormattedMessage defaultMessage="Student Distribution" id="student_distribution.4311af2f" />
                        </h6>
                        <Row className="text-center">
                            <Col md="6" xs="12">
                                <ReportToolTip
                                    id="resources-started-tooltip"
                                    tooltip={formatMessage({ id: 'percent_of_course_resources_launched_at.d306cee9', defaultMessage: 'Percent of course resources launched at least once by students.' })}
                                    trigger="hover"
                                >
                                    <Circle label={formatMessage({ id: 'percent_of_resources_started.e8335acf', defaultMessage: '% of Resources Started' })} value={resourceMetrics.resourcesStartedPercent} />
                                </ReportToolTip>
                            </Col>
                            <Col md="6" xs="12">
                                <ReportToolTip
                                    id="resources-completed-tooltip"
                                    tooltip={formatMessage({ id: 'percent_of_course_resources_that_all_stu.92bbad11', defaultMessage: 'Percent of course resources that all students have completed.' })}
                                    trigger="hover"
                                >
                                    <Circle label={formatMessage({ id: 'percent_of_resources_completed.6cd2db62', defaultMessage: '% of Resources Completed' })} value={resourceMetrics.resourcesCompletedPercent} />
                                </ReportToolTip>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                {/* Student Averages */}
                <Col className="pe-0" md="6" xs="12">
                    <Card className="p-3 shadow-sm h-100">
                        <h6 className="fw-semibold mb-3">
                            <FormattedMessage defaultMessage="Student Averages" id="student_averages.6380fee9" />
                        </h6>
                        <Row className="text-center align-items-center">
                            <Col md="6" xs="12">
                                <ReportToolTip
                                    tooltip={formatMessage({ id: 'average_of_students_highest_scores_acros.f66d0253', defaultMessage: 'Average of students\' highest scores across scored resources.' })}
                                    trigger="hover"
                                >
                                    <Circle label={formatMessage({ id: 'average_score.3cb75673', defaultMessage: 'Average Score' })} value={resourceMetrics.averageScore} />
                                </ReportToolTip>
                            </Col>
                            <Col md="6" xs="12">
                                <ReportToolTip
                                    tooltip={formatMessage({ id: 'average_time_students_have_spent_per_res.b7f86075', defaultMessage: 'Average time students have spent per resource within the selected date window.' })}
                                    trigger="hover"
                                >
                                    <div className="text-center my-3">
                                        <div className="fw-semibold text-secondary mb-2">
                                            <FormattedMessage defaultMessage="Average Time Spent" id="average_time_spent.411b3ea0" />
                                        </div>
                                        <div className="fw-bold fs-3">
                                            {calculateHourMinFormat(Math.round(resourceMetrics.averageTimeSpent))}
                                        </div>
                                    </div>
                                </ReportToolTip>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    ));

};
